<template>    
  <ul class="side_menu">
    <div class="title">防災サポート</div>
    <div class="d_top">
      <li class="li_top"><router-link to="/municipalityList">自治体</router-link></li>
      <li class="li_top"><router-link to="/companyList">企業</router-link></li>
      <li class="li_top"><router-link to="/notificationList">お知らせ</router-link></li>
    </div>
    <div class="d_bottom">
      <li class="li_bottom">{{ this.$store.getters.getStateAdminUser }}</li>
      <li class="li_bottom"><router-link to="/loginAdmin">ログアウト</router-link></li>
    </div>
  </ul>
</template>

<script>
export default {
  data: function() {
    return {}
  }
}
</script>

<style scoped>
.side_menu {
  width: 180px;
  height: 100vh;
  float: left;
  color: #ffffff;
  background-color: #144974;
  padding: 0;
  font-size: large;
  position: relative;
}
.title {
  text-align: left;
  padding: 15px 10px;
  border-bottom: 0.1px solid #ffffff;
}
ul {
  text-align: left;
  list-style: none;
}
.d_bottom {
	position: absolute;
	bottom: 0;
  margin-top: 300px;
}
li {
  width: 180px;
  padding: 12px 12px 12px 10px;
  color: #ffffff;
  font-size: 0.7em;
}
.li_top {
  border-bottom: 0.1px solid #ffffff;
  background-color: #144974;
}
.li_bottom {
  border-top: 0.1px solid #ffffff;
  background-color: #144974;
  vertical-align: middle;
}
a {
  color: #ffffff;
}
</style>